window.dataLayer = window.dataLayer || [];

export const logEvent = ({ eventName, data = {}, dataKey = 'data' }) => {
  // Events:
  // - login_process
  // - logout_process
  // - loggedin
  // - submit_activity
  // - checkin_activity
  // - checkout_activity
  // - upload_image
  // - create_sales_order
  // - add_product_sales_order
  window.dataLayer.push({
    event: eventName,
    [dataKey]: data,
  });
};

export const logEventScreen = (screen) => {
  if (screen && typeof screen === 'string') {
    const finalScreen = screen
      .replace('Screen', '')
      .replace(/([A-Z])/g, ' $1')
      .trim();
    window.dataLayer.push({
      event: screen,
      screen_name: finalScreen,
      screen_class: finalScreen,
    });
  }
};
